export default function delay(msecs) {
	return new Promise((resolve) => {
		setTimeout(() => {
			resolve();
		}, msecs);
	});
}